export default __webpack_public_path__ + "static/media/nord-sponsor-logo.282205d9.png";